<div class="setting-page">
  <legend>Global Normalization Before Routing</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="!canSubmit">
    <arm-form-title>Normalization Selection</arm-form-title>
    <div class="settings-section">
      <ac-input-container label="Source URI User" class="halfWidth">
        <ac-select [acModel]="globalPreRoutingManipulation.srcNormalization"
                   alternativeName="globalPreRoutingManipulation.srcNormalization"
                   (acModelChange)="globalPreRoutingManipulation.srcNormalization = $event"
                   [items]="manipulationGroups"
                   [bindValue]="'id'"
                   [bindLabel]="'groupName'"
                   selectId="src-manipulation-group-in-global-incoming-number-manipulation-form">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Destination URI User" class="halfWidth">
        <ac-select [acModel]="globalPreRoutingManipulation.destNormalization"
                   alternativeName="globalPreRoutingManipulation.destNormalization"
                   (acModelChange)="globalPreRoutingManipulation.destNormalization = $event"
                   [items]="manipulationGroups"
                   [bindValue]="'id'"
                   [bindLabel]="'groupName'"
                   selectId="dest-manipulation-group-in-global-incoming-number-manipulation-form">
        </ac-select>
      </ac-input-container>
    </div>
  </arm-form>
</div>
